import React from 'react';
import classNames from 'classnames';
import SVG from "react-inlinesvg";

import icn_remove from '../../../assets/svg/actions/icn-remove.svg';

const Chips = function (props) {

    const ref = React.useRef();

    React.useEffect(() => {});

    const className = () => {
        return classNames("chips", props.variant ?? 'light')
    }

    const removeTag = (e) => {
        e.preventDefault();

        if(props.removetag)
            props.removetag(props.accessKey);
    }

    return (
        <div key={props.accessKey} className={className()} ref={ref}>
            <div className="d-flex align-items-center">
                <span>{props.children}</span>
                <i onClick={removeTag}><SVG src={icn_remove}/></i>
            </div>
        </div>
    );
}

export default Chips;
